var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{ref:"destination-advice-modal-ref",attrs:{"id":"destination-advice-modal","hide-footer":"","title":"Destination Advice"}},[_c('div',[_c('DestinationAdviceBody')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }